export default "__VITE_ASSET__Bo6peaZ3__"